/**
 * Validates if all text fields of the report are filled for the indicators.
 * @param htmlReportString HTML string of the report
 * @returns true if everything is valided, false if validation failed
 */
export function validateIfIndicatorsAreSet(htmlReportString: string) {
	if (!htmlReportString) {
		return false;
	}

	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlReportString, 'text/html');

	// get all div elements with data-type="user-interactive" or data-type="user-interactive-fds"
	const indicatorElements = doc.querySelectorAll(
		'div[data-type="user-interactive"], div[data-type="user-interactive-fds"]',
	);

	if (indicatorElements.length < 1) {
		return false;
	}

	// check if they have child content and/or text
	for (const element of indicatorElements) {
		const hasText = element.textContent && element.textContent.trim().length > 0;

		if (!hasText) {
			return false;
		}
	}

	return true;
}
